"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToTop = void 0;
var scrollToTop = exports.scrollToTop = function scrollToTop() {
  var offsetY = window.etv && window.etv.scrollOffset + 10 || 0;
  if (window.scrollY > offsetY) {
    window.scrollTo(0, offsetY);
  }
};